/* ============================================================
   EXON PLACEMENTS (Placement Engine, Stage 3) — SSR-first hydration.
   Collect [data-placement] sections → ONE batch POST → per placement returned
   live|curated with >=4 items, swap [data-placement-track] with JS cards pixel-
   identical to product-card.liquid / the .vh-mini tile. The spotlight deck
   (data-placement-spotlight) is hydrated per-slot instead (Task 10). 'off'/empty/
   error keeps the SSR fallback; height reserved before each swap (zero CLS). Owns the
   recently-viewed ring buffer ('exon:rv'; window.__exonRV.push from product.js).
   Transport: App Proxy /apps/exon-offers/placement-api/placements first, then
   the legacy proxy path /apps/exon-offers/placements, then the direct edge URL
   (placement-api); the winning rung is remembered so later batches skip dead
   probes. Config: #exon-placements-cfg (theme.liquid). Silent.
   ============================================================ */
(function () {
  'use strict';
  if (window.__exonPlacementsInit) return;
  window.__exonPlacementsInit = true;

  /* config */
  function readCfg(id) {
    var el = document.getElementById(id);
    if (!el || !el.textContent) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }
  var CFG = readCfg('exon-placements-cfg'), UP = readCfg('exon-upsell-cfg');
  var SHOP = CFG.canonicalShop || UP.canonicalShop || '';
  var LOCALE = String(CFG.locale || UP.locale || 'he');
  var HE = LOCALE.slice(0, 2) !== 'en';
  var ROUTES = String(CFG.routesRoot || UP.routesRoot || '/').replace(/\/+$/, '') + '/';
  var MONEY_FMT = String(CFG.moneyFormat || UP.moneyFormat || '₪{{amount_no_decimals}}').replace(/<[^>]+>/g, '');
  var CASHBACK = numOf(CFG.cashbackPct);
  /* campaign cashback (layout/theme.liquid → snippets/cb-campaign.liquid):
     present only while the server says it runs; a listed handle shows the
     campaign rate until endsAt, then the store rate. The chip is marked so
     cards.js can return it at the end on a page left open. */
  var CBC = (CFG.cbCampaign && typeof CFG.cbCampaign === 'object') ? CFG.cbCampaign : null;
  function cbcChip(handle) {
    var base = CASHBACK > 0 ? CASHBACK + '% ' + T.cashback : '';
    var ends = CBC ? numOf(CBC.endsAt) : 0;
    var pct = CBC ? numOf(CBC.pct) : 0;
    var on = CBC && pct > CASHBACK && ends > Date.now() && Array.isArray(CBC.handles) &&
      CBC.handles.indexOf(String(handle || '')) !== -1;
    if (!on) return base ? '<span class="cb-mini">' + esc(base) + '</span>' : '';
    return '<span class="cb-mini" data-cbc-card data-cbc-ends="' + ends + '" data-cbc-base="' + esc(base) + '">' +
      esc(pct + '% ' + T.cashback) + '</span>';
  }
  var VICONS = (CFG.vendorIcons && typeof CFG.vendorIcons === 'object') ? CFG.vendorIcons : {};
  var VICON_DEFAULT = CFG.defaultVendorIcon || 'https://cdn.shopify.com/s/files/1/0526/0663/2093/files/default-vendor.png?v=1757498327';
  var PROXY_BASE = String(CFG.proxyBase || '/apps/exon-offers').replace(/\/+$/, '');
  /* preferred proxy subpath (post proxy-target change) → legacy proxy path →
     direct edge: the chain makes theme-deploy order vs the Partner-Dashboard
     proxy-target change irrelevant */
  var PROXY2_URL = PROXY_BASE + '/placement-api/placements';
  var PROXY_URL = PROXY_BASE + '/placements';
  var DIRECT_URL = deriveDirect(CFG.offerApiBase || UP.offerApiBase || '');
  var ENABLED = CFG.enabled !== false && !!SHOP;
  var FETCH_TIMEOUT_MS = 4500;

  var T = HE
    ? { cashback: 'קאשבק', releases: 'ישוחרר ב-', cloud: 'הפעלה בענן', add: 'הוסיפו לסל', from: 'מ-', buy: 'קנו עכשיו', po: 'הזמינו מראש' }
    : { cashback: 'cashback', releases: 'Releases', cloud: 'Cloud Activation', add: 'Add to cart', from: 'From', buy: 'Buy now', po: 'Pre-order now' };

  /* recently-viewed: 'exon:rv' = product gids, newest first, <=20, deduped */
  var RV_KEY = 'exon:rv';
  var RV_MAX = 20;
  function rvGet() {
    try {
      var a = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      return Array.isArray(a) ? a.filter(function (x) { return typeof x === 'string' && x; }) : [];
    } catch (e) { return []; }
  }
  function rvPush(gid) {
    gid = String(gid || '');
    if (!/^gid:\/\/shopify\/Product\/\d+$/.test(gid)) return;
    try {
      var a = rvGet().filter(function (x) { return x !== gid; });
      a.unshift(gid);
      if (a.length > RV_MAX) a = a.slice(0, RV_MAX);
      localStorage.setItem(RV_KEY, JSON.stringify(a));
    } catch (e) { /* private mode / quota — ignore */ }
  }
  window.__exonRV = { push: rvPush, get: rvGet };

  /* utils */
  function numOf(v) { var n = Number(v); return isFinite(n) ? n : 0; }
  function els(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function safeImg(u) { u = String(u || ''); if (/^\/\//.test(u)) return 'https:' + u; return /^https?:\/\//i.test(u) ? u : ''; }
  function gidToId(gid) { var m = String(gid || '').match(/(\d+)\s*$/); return m ? m[1] : ''; }
  function itemUrl(handle) { handle = String(handle || ''); return handle ? ROUTES + 'products/' + encodeURIComponent(handle) : '#'; }
  function commas(n, dec) {
    var parts = n.toFixed(dec).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return dec ? parts.join('.') : parts[0];
  }
  function moneyMinor(minor) {
    var n = numOf(minor) / 100;
    var out = MONEY_FMT
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, commas(n, 0))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, commas(n, 2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, commas(Math.round(n), 0))
      .replace(/\{\{\s*amount\s*\}\}/g, commas(n, 2));
    if (out === MONEY_FMT) out = '₪' + commas(Math.round(n), 0);
    return out.replace(/\.00(?!\d)/g, '');
  }
  function moneyMajor(major) { return moneyMinor(Math.round(numOf(major) * 100)); }
  function dmShort(iso) { var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || '')); return m ? m[3] + '.' + m[2] : ''; }
  function deriveDirect(base) {
    base = String(base || '').replace(/\/+$/, '');
    if (!base || base.indexOf('/') === -1) return '';
    return base.replace(/\/[^/]+$/, '/placement-api') + '/placements';
  }

  var ICON_PLUS = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5v14"/></svg>';
  /* banner chrome icons — verbatim from snippets/home-icon.liquid (flame 11px,
     hourglass 12px) and snippets/icon-arrow.liquid (RTL → left arrow). */
  var ICON_FLAME = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>';
  var ICON_HOURGLASS = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 22h14M5 2h14M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2"/></svg>';
  var ICON_ARROW = HE
    ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>'
    : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
  /* ---- product JSON (storefront /products/{handle}.js) — cache + timeout,
     mirrors upsell.js Products / the spotlight island's SpotProducts. Banner
     hydration needs the winning product's media to resolve wide art client-side
     (the engine's image_url is a portrait cover; wallpapers come from Shopify
     data per the P-BANNER design). Kept here so any placements.js hydrator can
     reuse it; the island keeps its own copy (separate script scope). ---- */
  var Products = (function () {
    var cache = {}, inflight = {}, TTL = 300000, MAX_ENTRIES = 128;
    function store(handle, product) {
      if (!cache[handle] && Object.keys(cache).length >= MAX_ENTRIES) {
        var oldest = Object.keys(cache)[0]; if (oldest) delete cache[oldest];
      }
      cache[handle] = { at: Date.now(), product: product };
    }
    function get(handle) {
      handle = String(handle || '').trim();
      if (!handle) return Promise.resolve(null);
      var hit = cache[handle];
      if (hit && Date.now() - hit.at < TTL) return Promise.resolve(hit.product);
      if (inflight[handle]) return inflight[handle];
      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, FETCH_TIMEOUT_MS) : null;
      var p = fetch(ROUTES + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }, credentials: 'same-origin',
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (prod) { store(handle, prod); return prod; })
        .catch(function () { store(handle, null); return null; })
        .then(function (prod) { if (timer) clearTimeout(timer); delete inflight[handle]; return prod; });
      inflight[handle] = p;
      return p;
    }
    return { get: get };
  })();
  /* pick-wide-media RULE 2, client-side: first media image with aspect >= 1.5.
     RULE 1 (exon.wide_image metafield) can't be read client-side. */
  function cdnWidth(src, w) {
    src = String(src || ''); if (!src) return '';
    if (/[?&]width=\d+/.test(src)) return src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function pickWide(prod) {
    if (!prod || !prod.media || !prod.media.length) return '';
    for (var m = 0; m < prod.media.length; m++) {
      var md = prod.media[m];
      if (md && md.media_type === 'image' && md.preview_image && md.preview_image.aspect_ratio >= 1.5) {
        return cdnWidth(md.preview_image.src, 1600);
      }
    }
    return '';
  }

  /* engine vendor_key → theme platform identity (icon + label + cloud-chip parity) */
  var VMAP = { microsoft: 'xbox', sony: 'playstation', valve: 'steam' };
  var VLABEL = { xbox: 'Xbox', playstation: 'PlayStation', steam: 'Steam', nintendo: 'Nintendo', software: 'תוכנות', giftcards: 'גיפט קארדים' };
  function vnorm(k) { k = String(k || '').toLowerCase(); return VMAP[k] || k; }

  function kindLabel(k) {
    var m = { game: 'משחק', software: 'תוכנה', subscription: 'מנוי', gift_card: 'גיפט קארד', giftcard: 'גיפט קארד', virtual_currency: 'כסף וירטואלי', currency: 'כסף וירטואלי' };
    return m[String(k || '').toLowerCase()] || '';
  }
  function vIcon(vkey) {
    var u = VICONS[vkey] || VICON_DEFAULT;
    return '<img class="v-ico" src="' + esc(u) + '" width="13" height="13" loading="lazy" alt="" onerror="this.onerror=null;this.src=\'' + esc(VICON_DEFAULT) + '\';">';
  }
  /* no-image fallback (upsell.js key-cover, glyph-less) */
  function keyCover() {
    return '<span class="key-cover"><span class="key-bloom"></span><span class="key-brand mono ltr">EXON · DIGITAL KEY</span><span class="key-lines"></span></span>';
  }
  /* Phase 3 reason chip (owner-approved design A, 2026-09-22): the engine's
     `why` element — "כי צפית ב-…", "בגלל … שבבעלותך", "כי … בעגלה שלך",
     "מוביל ב-… השבוע" — rendered as a quiet glass chip above the card name.
     The icon follows score_components.why_reason (viewed | owned | cart |
     popular); an unknown reason gets the sparkle. The element is OPTIONAL in
     the vocabulary: no element, no chip, nothing else changes. Text is the
     engine's, escaped; never composed here. */
  var WHY_ICONS = {
    viewed: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>',
    owned: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M4 19V5a1 1 0 011-1h3v15H5z"/><path d="M10 19V4h4v15z"/><path d="M16 19l2-14 3 .5-2 14z"/></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 002 1.6h9.7a2 2 0 002-1.6L23 6H6"/></svg>',
    popular: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M12 22c4.4 0 7-3 7-7 0-3-2-5.5-3.5-7-.5 2-1.5 3-2.5 3.5C13 9 12 6 9 3c0 3-1 5-3 7.5S5 15 5 15c0 4 2.6 7 7 7z"/></svg>',
    sparkle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"/></svg>'
  };
  function whyOf(o) {
    var list = o && o.elements;
    if (!list || !list.length) return null;
    for (var i = 0; i < list.length; i++) {
      var e = list[i];
      if (e && e.type === 'why' && e.text) return String(e.text);
    }
    return null;
  }
  function whyChipHtml(o) {
    var text = whyOf(o);
    if (!text) return '';
    var reason = String((o.score_components && o.score_components.why_reason) || o.why_reason || '').toLowerCase();
    var cls = 'why-chip';
    if (reason === 'owned') cls += ' own';
    else if (reason === 'popular') cls += ' pop';
    var icon = Object.prototype.hasOwnProperty.call(WHY_ICONS, reason) ? WHY_ICONS[reason] : WHY_ICONS.sparkle;
    return '<span class="' + cls + '" title="' + esc(text) + '">' + icon + '<span>' + esc(text) + '</span></span>';
  }
  /* card renderers (product-card.liquid parity) */
  function pcardHtml(o) {
    var url = itemUrl(o.handle);
    var title = String(o.title || '');
    var vid = gidToId(o.variant_gid);
    var img = safeImg(o.image_url);
    var vkey = vnorm(o.vendor_key);
    var vlabel = VLABEL[vkey] || o.vendor_key || '';
    var kindL = kindLabel(o.kind);
    var priceMinor = Math.round(numOf(o.price) * 100);
    var cmpMinor = (o.compare_at != null) ? Math.round(numOf(o.compare_at) * 100) : 0;
    var hasCompare = cmpMinor > priceMinor && priceMinor > 0;
    var pct = hasCompare ? Math.round((cmpMinor - priceMinor) / cmpMinor * 100) : 0;
    var pre = o.pre_order === true;
    var relShort = pre ? dmShort(o.release_date) : '';
    var pgid = String(o.product_gid || '');

    var s = '<article class="pcard" data-product-card data-product-url="' + esc(url) + '"' + (pgid ? ' data-product-gid="' + esc(pgid) + '"' : '') + (vid ? ' data-variant-id="' + esc(vid) + '"' : '') + '>';
    s += '<a class="art" href="' + esc(url) + '" aria-label="' + esc(title) + '">';
    if (img) s += '<img src="' + esc(img) + '" sizes="(max-width: 640px) 45vw, 258px" alt="' + esc(title) + '" width="520" height="619" loading="lazy">';
    else s += keyCover();
    if (pct > 0) s += '<span class="pct pct-art ltr">-' + pct + '%</span>';
    if (pre) s += '<span class="pc-badges"><span class="pc-badge po ltr">PRE-ORDER' + (relShort ? ' · ' + esc(relShort) : '') + '</span></span>';
    if (vid) s += '<button type="button" class="quick" data-quick-add title="' + esc(T.add) + '" aria-label="' + esc(T.add) + '">' + ICON_PLUS + '</button>';
    s += '</a>';

    s += '<div class="pinfo">' + whyChipHtml(o) + '<div class="pmeta"><span class="vchip">';
    if (vlabel) s += vIcon(vkey) + '<span style="text-transform:capitalize">' + esc(vlabel) + '</span>';
    if (kindL) s += '<i class="vchip-dot">·</i><span class="kind-l">' + esc(kindL) + '</span>';
    s += '</span></div>';
    s += '<a class="name" href="' + esc(url) + '">' + esc(title) + '</a>';
    s += '<div class="price-row"><span class="price"><span class="ltr">' + esc(moneyMinor(priceMinor)) + '</span></span>';
    if (hasCompare) s += '<span class="was ltr">' + esc(moneyMinor(cmpMinor)) + '</span>';
    s += cbcChip(o.handle);
    s += '</div>';
    s += revChip(o);
    /* bottom state row: status only (EXO-3596 #1) — pre-order; the delivery
       and cloud badges left the card. The engine serves available products,
       so product-card.liquid's sold-out branch has no JS twin. */
    if (pre) s += '<div class="pc-state">' + stateLine(relShort) + '</div>';
    s += '</div></article>';
    return s;
  }
  /* Judge.me aggregate — same .pc-rev/.rrev anatomy as product-card.liquid
     (the styled chip is the visible display; the Liquid-only preview badge
     is SSR-side and deliberately not reproduced). Gated on count > 0. */
  function revChip(o) {
    var count = numOf(o.review_count), rating = numOf(o.review_rating);
    if (!(count > 0) || !(rating > 0)) return '';
    var val = Math.round(rating * 10) / 10;
    return '<div class="pc-rev"><span class="rrev ltr" title="' + val + '/5 · ' + count + '">' +
      '<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14l-5-4.87 6.91-1.01z"/></svg>' +
      '<b>' + val + '</b><i>(' + count + ')</i></span></div>';
  }
  function stateLine(relShort) {
    var s = '<span class="pcs-chip vx ltr">PRE-ORDER</span>';
    if (relShort) s += '<span class="pcs-txt">' + esc(T.releases) + ' <b class="ltr">' + esc(relShort) + '</b></span>';
    return s;
  }
  /* .vh-mini tile (home-minigrid.liquid) */
  function miniHtml(o) {
    var url = itemUrl(o.handle);
    var title = String(o.title || '');
    var img = safeImg(o.image_url);
    var vkey = vnorm(o.vendor_key);
    var priceMinor = Math.round(numOf(o.price) * 100);
    var cmpMinor = (o.compare_at != null) ? Math.round(numOf(o.compare_at) * 100) : 0;
    var hasCompare = cmpMinor > priceMinor && priceMinor > 0;
    var pct = hasCompare ? Math.round((cmpMinor - priceMinor) / cmpMinor * 100) : 0;
    var pgid = String(o.product_gid || '');

    /* data-product-card lets the section click handler track + carrier-store mini
       tiles too (wallet / subscriptions dense shelves) — previously untracked. */
    var s = '<a class="vh-mini" href="' + esc(url) + '" data-product-card data-product-url="' + esc(url) + '"' + (pgid ? ' data-product-gid="' + esc(pgid) + '"' : '') + '><span class="m-art">';
    if (img) s += '<img src="' + esc(img) + '" sizes="128px" alt="' + esc(title) + '" width="300" height="357" loading="lazy">';
    else s += keyCover();
    if (hasCompare) s += '<i class="pct m-pct ltr">-' + pct + '%</i>';
    s += '</span><span class="m-name">' + esc(title) + '</span>';
    s += '<span class="m-price"><b class="ltr">' + esc(moneyMinor(priceMinor)) + '</b>';
    if (hasCompare) s += '<s class="ltr">' + esc(moneyMinor(cmpMinor)) + '</s>';
    s += '</span></a>';
    return s;
  }
  /* full-bleed feature banner (.vh-banner) — SAME markup shape as
     exon-home-banner.liquid / the hub feature_banner block, re-rendered with the
     engine's winning product + a client-resolved wide wallpaper. Tag (HOT /
     PRE-ORDER) follows the product's own preorder state; the CTA uses the
     section's localized voice (T.buy / T.po). data-product-card lets the shared
     wirePlacementEvents attribute clicks (single item, position 1). */
  function bannerHtml(o, wide) {
    var url = itemUrl(o.handle);
    var title = String(o.title || '');
    var vkey = vnorm(o.vendor_key);
    var priceMinor = Math.round(numOf(o.price) * 100);
    var cmpMinor = (o.compare_at != null) ? Math.round(numOf(o.compare_at) * 100) : 0;
    var hasCompare = cmpMinor > priceMinor && priceMinor > 0;
    var pre = o.pre_order === true;
    var rel = pre ? dmShort(o.release_date) : '';
    var cta = pre ? T.po : T.buy;

    var pgid = String(o.product_gid || '');
    var s = '<a class="vh-banner" href="' + esc(url) + '" data-vendor="' + esc(vkey) + '" data-product-card data-product-url="' + esc(url) + '"' + (pgid ? ' data-product-gid="' + esc(pgid) + '"' : '') + ' aria-label="' + esc(title) + '">';
    s += '<img src="' + esc(wide) + '" sizes="100vw" alt="" loading="lazy" width="1600" height="480">';
    s += '<span class="vh-banner-veil"></span>';
    s += '<div class="vh-banner-in">';
    if (pre) {
      s += '<span class="tag vx ltr">PRE-ORDER</span>';
      if (rel) s += '<span class="vh-banner-days">' + ICON_HOURGLASS + ' <span class="ltr">' + esc(rel) + '</span></span>';
    } else {
      s += '<span class="tag hot">' + ICON_FLAME + ' HOT</span>';
    }
    s += '<h3 class="ltr">' + esc(title) + '</h3>';
    s += '<div class="vh-banner-row"><span class="vh-banner-price ltr"><b>' + esc(moneyMinor(priceMinor)) + '</b>';
    if (hasCompare) s += '<s>' + esc(moneyMinor(cmpMinor)) + '</s>';
    s += '</span><span class="btn btn-speckle vh-banner-cta">' + esc(cta) + ' ' + ICON_ARROW + '</span>';
    s += '</div></div></a>';
    return s;
  }

  /* collect · batch · hydrate */
  function pageKind() {
    var p = (document.body && document.body.getAttribute('data-page')) || '';
    return p === 'vendor' ? 'hub' : 'home';
  }

  /* The cart ids only EXCLUDE in-cart families from the answer; they are not
     worth delaying the whole engine call for. The cart fetch races a short
     grace period: a fast cart rides along, a slow one is dropped and the call
     goes out with recently-viewed alone (measured 2026-09-21: the serial
     cart→engine chain was the first reason phones ran past the reveal). */
  var CART_GRACE_MS = 300;
  function gatherContext(hubVendor) {
    var ctx = { recently_viewed: rvGet().slice(0, 20), cart_variant_ids: [] };
    if (hubVendor) ctx.hub_vendor = hubVendor;
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, FETCH_TIMEOUT_MS) : null;
    var cart = fetch(ROUTES + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var ids = [];
        if (cart && cart.items) cart.items.forEach(function (it) {
          var vid = it.variant_id || it.id;
          if (vid) ids.push('gid://shopify/ProductVariant/' + vid);
        });
        ctx.cart_variant_ids = ids.slice(0, 50);
        return ctx;
      })
      .catch(function () { return ctx; })
      .then(function (c) { if (timer) clearTimeout(timer); return c; });
    var grace = new Promise(function (resolve) { setTimeout(function () { resolve(ctx); }, CART_GRACE_MS); });
    return Promise.race([cart, grace]);
  }

  function post(url, body, creds, timeoutMs) {
    if (!url) return Promise.resolve(null);
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, timeoutMs || FETCH_TIMEOUT_MS) : null;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
      credentials: creds,
      signal: ctrl ? ctrl.signal : undefined,
      body: body
    }).then(function (res) {
      if (timer) clearTimeout(timer);
      return res.ok ? res.json() : null;
    }).catch(function () {
      if (timer) clearTimeout(timer);
      return null;
    });
  }

  /* proxy first (same-origin cookies → signed identity); each failed rung
     falls to the next. The winning rung's index is remembered so any later
     batch in this JS context starts there instead of re-probing dead rungs.
     Payload is identical on every rung. The chain is budgeted UNDER run()'s
     2800ms backstop — early rungs get ~900ms each, the last rung whatever the
     budget has left — so ONE hung rung can never eat the whole window and
     convert a page whose next rung works into permanent SSR. A dead rung that
     answers fast (e.g. a 404) spends only its real latency, not its deadline,
     so the healthy-next-rung page still hydrates within one batch. */
  var RUNGS = [
    { url: PROXY2_URL, creds: 'same-origin' },
    { url: PROXY_URL, creds: 'same-origin' },
    { url: DIRECT_URL, creds: 'omit' }
  ];
  /* Deadlines, remeasured 2026-09-21 on the live hub: the signed App Proxy
     answers in ~0.5s on a desktop line and 1–2.5s on cellular. At 900ms the
     HEALTHY primary rung was being aborted on phones and the page fell to its
     static cards for good. Each rung now gets up to 2.5s, and the chain may
     outlive the 2800ms skeleton reveal: a late answer still swaps in (see
     run()), so the budget is a ceiling on wasted work, not on hope. */
  var RUNG_DEADLINE_MS = 2500;
  var CHAIN_BUDGET_MS = 8000;
  var rungStart = 0;
  /* a rung wins only with a REAL batch response — ok:true + placements map
     (placement-api contract); anything else falls through to the next rung */
  function validBatch(resp) {
    return !!(resp && resp.ok === true && resp.placements && typeof resp.placements === 'object');
  }
  function batch(payload) {
    var body = JSON.stringify(payload);
    var t0 = Date.now();
    function attempt(i) {
      if (i >= RUNGS.length) return Promise.resolve(null);
      var left = CHAIN_BUDGET_MS - (Date.now() - t0);
      if (left <= 0) return Promise.resolve(null);
      var deadline = i < RUNGS.length - 1 ? Math.min(RUNG_DEADLINE_MS, left) : left;
      return post(RUNGS[i].url, body, RUNGS[i].creds, deadline).then(function (resp) {
        if (validBatch(resp)) { rungStart = i; return resp; }
        return attempt(i + 1);
      });
    }
    return attempt(rungStart);
  }

  function hydrate(sec, items) {
    var track = sec.querySelector('[data-placement-track]');
    if (!track) return;
    var mini = track.classList.contains('vh-mini-grid');
    var max = parseInt(sec.getAttribute('data-placement-max') || '0', 10) || items.length;
    var html = '';
    for (var i = 0; i < items.length && i < max; i++) {
      var it = items[i];
      if (!it || !it.handle) continue;
      html += mini ? miniHtml(it) : pcardHtml(it);
    }
    if (!html) return;
    /* reserve height so the swap can't shift the page (zero CLS) */
    var h = track.getBoundingClientRect().height;
    if (h) track.style.minHeight = Math.round(h) + 'px';
    track.innerHTML = html;
    /* fail-closed reveal: a shelf shipped `hidden` (SSR couldn't fill it
       honestly) unhides ONLY on a real engine swap — reached only for
       live|curated with >=4 items; off/empty/error never gets here. */
    if (sec.hasAttribute('data-placement-reveal')) sec.removeAttribute('hidden');
  }

  /* ---- banner hydrator (P-BANNER Phase A) --------------------------------
     Full-bleed banner mounts (data-placement-kind="banner", max 1). The engine
     returns up to 3 ranked products; the theme resolves each candidate's wide
     wallpaper from its own storefront JSON (engine art is a portrait cover).
     Walk the candidates: first product whose JSON fetches AND yields a landscape
     image (>=1.5) wins — a full-bleed slot needs wide art, so a fetch failure OR
     no-landscape falls to the next candidate. All three exhausted → keep the SSR
     merchant banner. The wallpaper is preloaded before the swap (no flash); the
     swap preserves the section's .vh-banner markup shape, only re-rendering the
     product content. ---- */
  function hydrateBanner(sec, items, key, token) {
    var list = (items || []).slice(0, 3), idx = 0;
    function tryNext() {
      if (idx >= list.length) return; /* all candidates failed → SSR banner stays */
      var o = list[idx++];
      if (!o || !o.handle) { tryNext(); return; }
      Products.get(o.handle).then(function (prod) {
        if (!prod) { tryNext(); return; }        /* JSON fetch failed/aborted → next */
        var wide = pickWide(prod);
        if (!wide) { tryNext(); return; }         /* no landscape art → next candidate */
        var im = new Image();
        im.onload = function () { swapBanner(sec, o, wide, key, token); };
        im.onerror = function () { tryNext(); };  /* image failed to load → next */
        im.src = wide;
      });
    }
    tryNext();
  }
  function swapBanner(sec, o, wide, key, token) {
    sec.innerHTML = bannerHtml(o, wide);
    /* record the DISPLAYED product on the section: the hydrator may fall back to
       items[1]/[2], and the engine keeps per-product impression counters, so the
       impression must carry which product actually rendered (set before wiring so
       the impression observer can read it). */
    if (o.product_gid) sec.setAttribute('data-displayed-gid', o.product_gid);
    /* fade the swapped banner in (CSS .plc-swapped .vh-banner); WAAPI-free so it
       shares Build-1's plcFade + reduced-motion handling */
    sec.classList.add('plc-swapped');
    wirePlacementEvents(sec, key, token || null, 1);
  }

  /* Spotlight deck hydration is a bespoke, per-slot swap that manipulates the
     rotating deck's own DOM + rotation state — it lives in the section island
     (sections/exon-home-spotlight.liquid), exposed as sec.__exonSpot.hydrate.
     placements.js just hands it the slot items + the shared card helpers so the
     deck's copy/price render identically to the rails without duplicating them. */
  var SPOT_HELP = { esc: esc, img: safeImg, money: moneyMinor, num: numOf, vnorm: vnorm, url: itemUrl, keyCover: keyCover };

  /* ---- placement telemetry: batched best-effort POST /events, mirroring the
     popup's transport (idempotency keys, beacon on hide). One impression per
     placement at 50% visibility (metadata carries item count), one click per
     item (position + gids). Uses the PER-PLACEMENT attribution token the API
     persists server-side; no token → no event. ---- */
  var EV = (function () {
    var q = [], t = null;
    function uuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
    }
    function track(evt) {
      if (!evt || !evt.attribution_token) return;
      evt.idempotency_key = uuid();
      q.push(evt);
      /* clicks navigate away, killing the batch timer before it fires — flush
         them immediately (keepalive fetch, initiated while the doc is alive,
         survives the navigation). Impressions keep the 1200ms batch. */
      if (evt.event === 'click') { flush(false); return; }
      if (!t) t = setTimeout(function () { flush(false); }, 1200);
    }
    function flush(beacon) {
      if (t) { clearTimeout(t); t = null; }
      if (!q.length) return;
      var payload = JSON.stringify({ shop_domain: SHOP, events: q.splice(0, q.length) });
      var u = (CFG.offerApiBase || UP.offerApiBase || '').replace(/\/+$/, '') + '/events';
      if (!u || u === '/events') return;
      try {
        if (beacon && navigator.sendBeacon) {
          navigator.sendBeacon(u, new Blob([payload], { type: 'application/json' }));
        } else {
          fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit', keepalive: true, body: payload }).catch(function () {});
        }
      } catch (e) { /* best-effort */ }
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flush(true);
    });
    /* pagehide is the reliable same-tab navigation signal desktop Chrome fires
       when visibilitychange doesn't; flush is idempotent so a double-fire is a
       no-op. */
    window.addEventListener('pagehide', function () { flush(true); });
    return { track: track };
  })();

  /* ---- attribution carrier (P-BANNER B1): last-touch placement click →
     sessionStorage, read on the PDP add-to-cart (product.js plcProps) to stamp
     cart line-item properties. Key 'exon_plc_attr' = { product_gid → {t: token,
     k: placement_key, ts} }, capped, 24h TTL enforced at read time. All access
     try/catch-wrapped (Safari private mode). Does not affect event tracking. ---- */
  var PLC_ATTR_KEY = 'exon_plc_attr';
  var PLC_ATTR_MAX = 20;
  function plcAttrStore(gid, token, key) {
    if (!gid || !token) return;
    try {
      var raw = sessionStorage.getItem(PLC_ATTR_KEY);
      var map = raw ? (JSON.parse(raw) || {}) : {};
      map[String(gid)] = { t: String(token), k: String(key || ''), ts: Date.now() };
      var ks = Object.keys(map);
      if (ks.length > PLC_ATTR_MAX) {
        ks.sort(function (a, b) { return (map[a].ts || 0) - (map[b].ts || 0); });
        while (ks.length > PLC_ATTR_MAX) { delete map[ks.shift()]; }
      }
      sessionStorage.setItem(PLC_ATTR_KEY, JSON.stringify(map));
    } catch (e) { /* private mode / quota — ignore */ }
  }

  function wirePlacementEvents(sec, key, token, itemCount) {
    if (!token) return;
    /* impression: once, when half the section is on screen */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.disconnect();
          EV.track({
            event: 'impression', surface: 'placement:' + key, attribution_token: token,
            /* product_gid = the displayed product (banner sections only carry
               data-displayed-gid; other surfaces leave it undefined → dropped) */
            metadata: { placement_key: key, item_count: itemCount, product_gid: sec.getAttribute('data-displayed-gid') || undefined }
          });
        });
      }, { threshold: 0.5 });
      io.observe(sec);
    }
    /* clicks: any hydrated card (rail) or hydrated slide (spotlight) */
    sec.addEventListener('click', function (e) {
      var card = e.target.closest('[data-product-card],[data-spotlight-slot]');
      if (!card || !sec.contains(card)) return;
      var a = card.querySelector('a[href]');
      /* verifiable product identity (pairs with the engine click-trust fix): the
         engine validates these against the served candidate set and rejects a
         banner click without them. product_gid is on every tracked surface;
         variant_gid only where a card exposes a variant (pcard quick-add). */
      var cvid = card.getAttribute('data-variant-id');
      EV.track({
        event: 'click', surface: 'placement:' + key, attribution_token: token,
        metadata: {
          placement_key: key,
          product_url: card.getAttribute('data-product-url') || (a ? a.getAttribute('href') : null),
          product_gid: card.getAttribute('data-product-gid') || undefined,
          variant_gid: cvid ? 'gid://shopify/ProductVariant/' + cvid : undefined,
          position: Array.prototype.indexOf.call(els('[data-product-card]', sec), card) + 1,
          slot: card.getAttribute('data-spotlight-slot') || undefined
        }
      });
      /* last-touch: remember this click's token↔product for the PDP carrier */
      plcAttrStore(card.getAttribute('data-product-gid'), token, key);
    }, { capture: true, passive: true });
  }

  /* ---- skeleton reveal (owner directive: engine-first, no SSR flash) ------
     The inline stamper (layout/theme.liquid) sets html.plc-skel before first
     paint so rail/minigrid/shelf placements render a loading skeleton (cards.css)
     instead of flashing the SSR fallback. run() resolves each section by adding
     .plc-live (offers on success, SSR on off/empty/<4/error/timeout — both fade
     in ~200ms) and OWNS the stamper's independent 3500ms failsafe. ---- */
  var HTML = document.documentElement;
  function cancelFailsafe() {
    try { if (window.__exonPlcSkel && window.__exonPlcSkel.cancel) window.__exonPlcSkel.cancel(); } catch (e) {}
  }
  function revealSection(sec) { if (sec) sec.classList.add('plc-live'); }
  /* drop the global skeleton flag; resolved sections keep their own .plc-live so
     this only affects anything still skeletoned. Cancels the inline failsafe
     first so it can't re-fire once run() has taken ownership. */
  function unskel() { cancelFailsafe(); try { HTML.classList.remove('plc-skel'); } catch (e) {} }

  function run() {
    var sections = els('[data-placement]');
    /* disabled kill-switch or no placement sections: reveal the SSR immediately —
       never leave a skeleton up for content JS is not going to touch */
    if (!sections.length || !ENABLED) { unskel(); return; }

    var order = [];
    var byKey = {};
    var hubVendor = null;
    var skel = []; /* SSR sections under the skeleton (visible rail/minigrid/shelf) */
    /* once the backstop reveals the SSR the page is settled. A late batch still
       swaps in — with a fade — UNLESS the visitor is engaged with that shelf
       (pointer over it, a finger on it, or focus inside it): the one case where
       replacing cards is worse than showing the static ones. Before this the
       late answer was thrown away wholesale, which on phones meant the engine
       almost never reached the hub (measured 2026-09-21). */
    var settled = false;
    function markEngaged(sec) { sec.__exonEngaged = true; }
    sections.forEach(function (sec) {
      sec.addEventListener('pointerenter', function () { markEngaged(sec); });
      sec.addEventListener('touchstart', function () { markEngaged(sec); }, { passive: true });
      sec.addEventListener('focusin', function () { markEngaged(sec); });
    });
    /* hard backstop: the skeleton may not outlive ~2800ms whatever the transport
       does. Armed BEFORE the inline failsafe is cancelled so no window exists
       with neither armed; `skel` fills synchronously below, long before 2800ms. */
    var backstop = setTimeout(function () { settled = true; skel.forEach(revealSection); unskel(); }, 2800);
    cancelFailsafe(); /* run() owns the reveal — the 2800ms backstop is tighter than the inline 3500ms failsafe */

    sections.forEach(function (sec) {
      var k = sec.getAttribute('data-placement');
      if (!k) return;
      if (!byKey[k]) { byKey[k] = []; order.push(k); }
      byKey[k].push(sec);
      var v = sec.getAttribute('data-placement-vendor');
      if (v && !hubVendor) hubVendor = v;
      /* only the skeletoned kinds need an explicit reveal: a `hidden` reveal-shelf
         is display:none (nothing painted) and spotlight/banner keep their own
         swap-fade, so none of those enter the skeleton set. */
      var kind = sec.getAttribute('data-placement-kind');
      if ((kind === 'rail' || kind === 'minigrid' || kind === 'shelf') &&
          !sec.hasAttribute('hidden') &&
          !sec.hasAttribute('data-placement-spotlight')) {
        skel.push(sec);
      }
    });
    if (!order.length) { clearTimeout(backstop); skel.forEach(revealSection); unskel(); return; }

    gatherContext(hubVendor).then(function (ctx) {
      var payload = { shop_domain: SHOP, page: pageKind(), placements: order.slice(0, 12), context: ctx };
      if (hubVendor) payload.hub_vendor = hubVendor;
      return batch(payload);
    }).then(function (resp) {
      clearTimeout(backstop);
      if (resp && resp.placements) {
        order.forEach(function (k) {
          var pl = resp.placements[k];
          if (!pl) return;
          var live = pl.status === 'live' || pl.status === 'curated';
          if (!live || !Array.isArray(pl.items) || !pl.items.length) return;
          byKey[k].forEach(function (sec) {
            /* spotlight hydrates per-slot (any count ≥1 — a slot can be omitted);
               rails need a full deck (≥4) before swapping the SSR fallback. */
            var hydrated = false;
            if (sec.hasAttribute('data-placement-spotlight')) {
              if (sec.__exonSpot && sec.__exonSpot.hydrate) { sec.__exonSpot.hydrate(pl.items, SPOT_HELP); hydrated = true; }
            } else if (sec.getAttribute('data-placement-kind') === 'banner') {
              /* banner hydration is async (per-candidate product-JSON fetch +
                 wallpaper preload); it wires its own events + plc-swapped fade on a
                 successful swap. Never skeletoned, so nothing to reveal here. */
              hydrateBanner(sec, pl.items, k, pl.attribution_token || null);
            } else if (pl.items.length >= 4) {
              /* late success after the backstop already revealed this section's
                 SSR: swap unless the visitor is engaged with THIS shelf; the
                 swap fades (.plc-swapped, cards.css) and keeps the reserved
                 height, so nothing jumps. Skipped sections stay untracked. */
              var late = settled && sec.classList.contains('plc-live');
              if (late && sec.__exonEngaged) return;
              hydrate(sec, pl.items);
              if (late) { sec.classList.remove('plc-swapped'); void sec.offsetWidth; sec.classList.add('plc-swapped'); }
              /* engine offers replace the SSR cards; .plc-live drops the skeleton
                 for this section and fades the fresh deck in (CSS plcSkelReveal).
                 The reveal shelf also unhides inside hydrate(). */
              revealSection(sec);
              hydrated = true;
            }
            /* telemetry only for engine-hydrated content (SSR fallback stays
               untracked — curation isn't the engine's to claim). Banners wire
               their own events post-swap inside hydrateBanner. */
            if (hydrated) wirePlacementEvents(sec, k, pl.attribution_token || null, pl.items.length);
          });
        });
      }
      /* off/empty/<4/error/no-key: reveal the SSR fallback (fades in ~200ms) so a
         default appears LATE, never flashing before the engine could answer */
      skel.forEach(revealSection);
      unskel();
    }).catch(function () { clearTimeout(backstop); skel.forEach(revealSection); unskel(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
